export function safeParseInt(val: unknown, defaultValue: number = 0): number {
  if (typeof val === "number") return val;

  if (typeof val === "string") {
    const value = Number.parseInt(val.replace(/\D+/g, ""));

    if (isNaN(value)) {
      return defaultValue;
    }

    return value;
  }

  return defaultValue;
}

export function pad(str: string, max: number = 2, value: string = "0"): string {
  return str.length < max ? pad(value + str, max, value) : str;
}

export function getNumberWithSign(value?: number | null, round: boolean = true): string {
  if (typeof value !== "number") return "—";

  return `${value > 0 ? "+" : ""}${round ? Math.floor(value) : value}`;
}

export function getMaybeTruncatedNumber(value?: number | null, decimals: number = 1): number | undefined {
  if (typeof value !== "number") return;

  return Math.trunc(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
